<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="normal">Dedication &amp;</p>
<p class="normal1"><span class="char-style-override">Thanks</span><span class="char-style-override"></span></p>
<p class="normal"></p>
<p class="normal1"><span class="char-style-override1">Lily Girl’s Christmas Quilt</span></p>
<p class="dedication"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">Christmas has always been my favorite season, so writing a Christmas book always makes me happy. I dedicate this book to my husband, Keith, who also shares my love of Christmas. My two sons, Joel and Jason Watkins, continue to be supportive and have given me many great Christmas memories.</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">My thanks to all the hardworking residents and businesses in the wine country region who spend an incredible amount of volunteer hours to bring a merry Christmas to all their visitors each year. I encourage everyone to experience Christmas in Missouri’s wine country.</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">From my family and C&amp;T Publishing, we wish you a very merry Christmas!</span><span class="dedication1"></span></p>
</div>
<div class="basic-text-frame">
<p class="normal2"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lily_Girl_split2.vue?ed1a7b26